<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="airRefundableObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger for flights that are <span class="rule-config-variable" @click="isEdit = !isEdit">
                            {{ boolToStr(airRefundableObj.value) }}
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span>
                    </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="airRefundableObj.isActive" v-model="airRefundableObj.isActive"
                        @input="airRefundable" :left-label="true">{{ airRefundableObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy editTravel2">
            <AirRefundable :refundableVal="refundableVal" @emitData="getValue" />
            <b-button @click="saveCall">SAVE</b-button>
        </div>
        <StandardRuleActions v-if="airRefundableObj.isActive && !isEdit" :ruleObj="airRefundableObj"
            :title="title" @save="updateActions" />
    </div>
</template>
<script>
import AirRefundable from "../CommonRules/AirRefundable.vue";
import StandardRuleActions from "../StandardRuleActions.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: { 
        AirRefundable,
        StandardRuleActions
     },
    data() {
        return {
            refundableVal: false,
            airRefundableObj: this.value
                ? this.value
                : {
                    name: "airRefundable",
                    isActive: false,
                    type: "air",
                    message: "Trigger for Refundable fares.",
                    value: false
                },
            isEdit: false,
            emitedValue: null,
            title: "Refundability"
        };
    },
    methods: {
        airRefundable() {
            if (!this.airRefundableObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            } else {
                // Rebuild message when activating
                this.buildMessage();
            }

            this.emitRuleObj();
        },
        getValue(val) {
            this.emitedValue = val;
        },
        saveCall() {
            this.isEdit = false;
            this.airRefundableObj.value = this.emitedValue;
            this.buildMessage();
        },
        boolToStr(bool){
            if(bool == true){
                return  'Non-Refundable'
            }else{
                return 'Refundable'
            }
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.airRefundableObj.useCustomActions = false;
            delete this.airRefundableObj.visibility;
            delete this.airRefundableObj.approvalLevel;
            delete this.airRefundableObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into airRefundableObj
            this.airRefundableObj = { ...this.airRefundableObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams();
            }

            this.buildMessage();

            this.emitRuleObj();
        },
        buildMessage() {

             this.airRefundableObj.message = "Trigger if fare is " + this.boolToStr(this.airRefundableObj.value);
       
            },
        emitRuleObj() {
            this.$emit("airRefundable", this.airRefundableObj);
        }
    },
    mounted() {
        this.airRefundableObj.type = "air";
        
        this.emitRuleObj();
    },
    computed: {
        typOfFlights() {
            if (this.airRefundableObj.value) {
                return 'Non-Refundable'
            } 
            return 'Refundable'
        }
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    const airfareProps = this.value;
                    this.airRefundableObj = airfareProps
                    this.refundableVal = airfareProps.value;
                    
                }
                this.airRefundableObj.type = "air";
                this.buildMessage();
                this.emitRuleObj();

            },
            deep: true,
        },
    },
};
</script>
  